// extracted by mini-css-extract-plugin
module.exports = {"headerName":"Header_headerName__2NwV2","icon":"Header_icon__1O-eS","text":"Header_text__16ZaJ"};